import * as React from 'react';
export var ApplicationLauncherItemContext = React.createContext({
  isExternal: false,
  icon: null
});